import styled from 'styled-components';
import { AXSBlock } from '@axs/axs-ui';
import parseColor from '@axs/axs-ui/dist/utils/colorHelpers';
import { colors } from '@axs/axs-ui/dist/constants/colors';

export const ClippedText = styled(AXSBlock)`
    color: ${({ theme }) => parseColor('axsui.text.primary', theme, colors.GREY_400) };
    line-height: ${({ lineHeight }) => lineHeight ? lineHeight : '50px' };
`;
